var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payroll_Concept",
    "data-name": "Payroll Concept"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.23,12.55,16.51,4.83a.87.87,0,0,0-.64-.27,1,1,0,0,0-.7.27,1,1,0,0,0-.33.64V9.06H8.42a1,1,0,0,0-1,1v6.26a1,1,0,0,0,1,1h6.42v3.59a1,1,0,0,0,1,.91.91.91,0,0,0,.66-.27l7.72-7.72a.87.87,0,0,0,.27-.64A.86.86,0,0,0,24.23,12.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7,22.56H5.51a4,4,0,0,1-4-4V7.44a4,4,0,0,1,4-4H10.7a1,1,0,0,1,0,2H5.51a2,2,0,0,0-2,2V18.56a2,2,0,0,0,2,2H10.7a1,1,0,0,1,0,2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log_out.93f0869fd13994a0a89f5b1238a91273.svg";
export { ForwardRef as ReactComponent };